module.exports = __webpack_public_path__ + "static/img/chat-dots.1d509e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/chat-dots.svg
// module id = Kvgi
// module chunks = 6